import React from 'react'

function time() {
    return (
        
        <div id="quiz-instruction-time">
            <h2 className="quiz-instruction-alignleft">INSTRUCTIONS</h2>
            <h2 className="quiz-instruction-alignright">TIME : 45.00 MIN</h2>
        </div>
    )
}

export default time
